import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { AzureAD, AuthenticationState } from 'react-aad-msal';
import { authProvider } from './authProvider';
import LoggedApp from './index_logged.js';

async function initApp(){
  
      ReactDOM.render(
        <AzureAD provider={authProvider} forceLogin={true}>
          {
            ({login, logout, authenticationState, error, accountInfo}) => {
              switch (authenticationState) {
                case AuthenticationState.Authenticated:
                  //console.log(accountInfo.account.idToken.employeeid)
                  localStorage.setItem('n_number',accountInfo.account.idToken.employeeid)
                  localStorage.setItem('token',accountInfo.jwtIdToken)
                  return(<LoggedApp />);
                case AuthenticationState.Unauthenticated:
                  return (
                    <div>
                      {error && <p><span>An error occured during authentication, please try again!</span></p>}
                      <p>
                        <button onClick={login}>Login</button>
                      </p>
                    </div>
                  );
                case AuthenticationState.InProgress: default:
                  return (<p>Authenticating...</p>);
              }
            }
          }
        </AzureAD>,
        document.getElementById("root")
      );
    
  }

initApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
